import MapCarousel from './MapCarousel'

export default MapCarousel
